import InfoIcon from '@mui/icons-material/Info';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormFieldNames } from '../../../validations/assignRfidCardValidationSchema';
import Alert from '../../Alert';
import RadioGroup from '../../HookFormFields/RadioGroup';
import messages from '../messages';

interface IRadioGroupCardType {
  dormakabaContent?: ReactNode;
  standardContent?: ReactNode;
}

function RadioGroupCardType({ dormakabaContent, standardContent }: IRadioGroupCardType) {
  const { formatMessage } = useIntl();
  const { watch } = useFormContext();
  const isStandardCard = watch(FormFieldNames.CardType) === FormFieldNames.StandardCard;
  const isDormakabaCard = watch(FormFieldNames.CardType) === FormFieldNames.DormakabaCard;

  return (
    <>
      <RadioGroup name={FormFieldNames.CardType}>
        <FormControlLabel
          control={<Radio />}
          value={FormFieldNames.DormakabaCard}
          label={formatMessage(messages.userRfidModalCardDormakabaLabel)}
        />
        <Typography variant="caption" sx={{ color: 'text.secondary', pl: 4 }}>
          <FormattedMessage {...messages.userRfidModalCardDormakabaHelper} />
        </Typography>
        {isDormakabaCard && dormakabaContent}
        <FormControlLabel
          control={<Radio />}
          value={FormFieldNames.StandardCard}
          label={formatMessage(messages.userRfidModalCardNormalLabel)}
        />
        <Typography variant="caption" sx={{ color: 'text.secondary', pb: 0, pl: 4 }}>
          <FormattedMessage {...messages.userRfidModalCardNormalHelper} />
        </Typography>
        {isStandardCard && standardContent}
      </RadioGroup>
      {isStandardCard && (
        <Alert severity="warning" icon={<InfoIcon />}>
          <FormattedMessage {...messages.userRfidModalCardDormakabaAlert} />
        </Alert>
      )}
    </>
  );
}

export default RadioGroupCardType;
